import React, { useState } from 'react';
import { CornerDownLeft } from 'lucide-react';

/**
 * The reply line of a USSD session. In a real session this is where you answer,
 * so on this site it is where you actually talk to the assistant.
 */
function UssdInput({ onSubmit, placeholder = 'Type a question', label = 'Reply' }) {
  const [value, setValue] = useState('');

  const submit = (event) => {
    event.preventDefault();
    const trimmed = value.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
    setValue('');
  };

  return (
    <form onSubmit={submit} className="flex items-center gap-2">
      <label htmlFor={`ussd-${label}`} className="sr-only">{label}</label>
      <span aria-hidden="true" className="text-panel-signal select-none">&gt;</span>
      <input
        id={`ussd-${label}`}
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        className="min-w-0 flex-1 border-0 bg-transparent p-0 font-mono text-sm text-panel-foreground placeholder:text-panel-muted focus:outline-none focus:ring-0"
      />
      <button
        type="submit"
        disabled={!value.trim()}
        aria-label="Send"
        className="grid h-7 w-7 shrink-0 place-items-center rounded-sm text-panel-muted transition-colors hover:bg-white/10 hover:text-panel-signal disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-panel-muted"
      >
        <CornerDownLeft className="h-3.5 w-3.5" />
      </button>
    </form>
  );
}

export default UssdInput;
